// filtri da listare nello spazio in alto
var filtersToList = [];

// dati da passare alla richiesta
var filters = [];
var measures = [];
var capacities = [];

// array di parametri (chiavi misure, template filtri, ecc...)
var measureKeys = ["RGB_W_MISURA_1L", "RGB_W_MISURA_1D", "RGB_W_MISURA_1W", "RGB_W_MISURA_1H", "RGB_W_MISURA_2L", "RGB_W_MISURA_2D", "RGB_W_MISURA_2W", "RGB_W_MISURA_2H"];
var measureKeysDistinct = ["from", "to"];

if (typeof rangeLabels == 'undefined') {
  var rangeLabels = {
    "RGB_W_MISURA_1L": "LARGH. GRANDE DA __VALUE_from__ A __VALUE_to__",
    "RGB_W_MISURA_1D": "PROF. GRANDE DA __VALUE_from__ A __VALUE_to__",
    "RGB_W_MISURA_1H": "ALT. GRANDE DA __VALUE_from__ A __VALUE_to__",
    "RGB_W_MISURA_1W": "Ø GRANDE DA __VALUE_from__ A __VALUE_to__",
    "RGB_W_MISURA_2L": "LARGH. PICCOLA DA __VALUE_from__ A __VALUE_to__",
    "RGB_W_MISURA_2D": "PROF. PICCOLA DA __VALUE_from__ A __VALUE_to__",
    "RGB_W_MISURA_2H": "ALT. PICCOLA DA __VALUE_from__ A __VALUE_to__",
    "RGB_W_MISURA_2W": "Ø PICCOLO DA __VALUE_from__ A __VALUE_to__",
    "RGB_W_CAPACITA": " CAPACITÁ __VALUE_UM__ DA __VALUE_from__ A __VALUE_to__"
  };
}

// elementi immutabili e spesso richiamabili del DOM
var filterListUl = $("#list-filters-applicated");
var youSearchedWrapperP = $("#you-searched-string-wrapper");

/**
 * legge i filtri selezionati e invia una richiesta al server per caricare i cataloghi
 */
function filterCatalogs(replaceFilters) {

    // sostituisce la lista dei filtri
    if(typeof replaceFilters != "undefined" && replaceFilters) {
        filterListUl.find("#filter-wrapper").find(".summary-filter-search-element").remove();
        filterListUl.find("#filter-wrapper").find(".summary-filter-range-search-element").remove();
    }

    // azzeramento variabili
    filters = [];
    capacities = [];
    measures = [];
    filtersToList = [];
    var showFilterList = false;

    // filtri capacità
    if($("input[name='RGB_W_CAPACITA-to']").val() || $("input[name='RGB_W_CAPACITA-from']").val()) {

        var listElementLabel = rangeLabels["RGB_W_CAPACITA"];

        capacities["RGB_W_CAPACITA_UM"] = $("select[name='RGB_W_CAPACITA_UM']").val();
        listElementLabel = listElementLabel.replace("__VALUE_UM__", $("select[name='RGB_W_CAPACITA_UM']").find("option:selected").text())

        capacities["RGB_W_CAPACITA"] = {};
        if($("input[name='RGB_W_CAPACITA-to']").val()) {
            capacities["RGB_W_CAPACITA"].to = $("input[name='RGB_W_CAPACITA-to']").val();
            listElementLabel = listElementLabel.replace("__VALUE_to__", capacities["RGB_W_CAPACITA"].to)
        } else {
            listElementLabel = listElementLabel.replace("__VALUE_to__", "-")
        }

        if($("input[name='RGB_W_CAPACITA-from']").val()) {
            capacities["RGB_W_CAPACITA"].from = $("input[name='RGB_W_CAPACITA-from']").val();
            listElementLabel = listElementLabel.replace("__VALUE_from__", capacities["RGB_W_CAPACITA"].from)
        } else {
            listElementLabel = listElementLabel.replace("__VALUE_from__", "-")
        }

        showFilterList = true;

        // sostituisce la lista dei filtri
        if(typeof replaceFilters != "undefined" && replaceFilters) {
            var liElement = generateFilterRangeListElement("RGB_W_CAPACITA", listElementLabel);
            filtersToList.push(liElement);
        }
    }

    // filtri misure
    for(var i = 0; i < measureKeys.length; i++) {
        var key = measureKeys[i];
        var listElementLabel = rangeLabels[key];
        var noValues = true;
        for(var j = 0; j < measureKeysDistinct.length; j++) {
            var distinct = measureKeysDistinct[j];
            var inputName = key + "-" + distinct;
            var element = $("input[name='"+inputName+"']");
            if(element.val()) {
                // initialize subarray
                if(typeof measures[key] == "undefined") { measures[key] = []; }
                // push value
                measures[key][distinct] = element.val();
                listElementLabel = listElementLabel.replace("__VALUE_"+distinct+"__", measures[key][distinct])
                // stampa il fltro, altrimenti se non ci sono valori non lo stampa
                noValues = false;
                showFilterList = true;
            } else {
                listElementLabel = listElementLabel.replace("__VALUE_"+distinct+"__", "-")
            }
        }
        if(!noValues) {
            // sostituisce la lista dei filtri
            if(typeof replaceFilters != "undefined" && replaceFilters) {
                var liElement = generateFilterRangeListElement(key, listElementLabel);
                filtersToList.push(liElement);
            }
        }
    }

    // filtri chiave-valore (colore, materiale, ecc..)
    var checkboxes = $("#search-filters").find("input:checked");

    var counter = checkboxes.length;
    if(counter) {

        showFilterList = true;

        // rimuove la classe hidden dal pulsante "rimuovi tutti i filtri"
        //if($('#remove-all-filters').hasClass('hidden')) {
        //    $('#remove-all-filters').removeClass('hidden');
        //}

        checkboxes.each(function (k, v) {

            var names = $(v).attr("name");
            names = names.split(",");

            // gestisce il doppio filtro MAT1,MAT2
            for(var n = 0; n < names.length; n++) {
                // initialize subarray
                if(typeof filters[names[n]] == "undefined") { filters[names[n]] = []; }
                // push value
                filters[names[n]].push($(v).val());
            }

            // sostituisce la lista dei filtri
            if(typeof replaceFilters != "undefined" && replaceFilters) {

                var liElement = generateFilterListElement($(v).attr("name"), $(v).val(), $(v).attr("data-label"));
                filtersToList.push(liElement);
            }

            if(!--counter) {
                pushFiltersToList(filtersToList);
                // load risultati
                setTimeout(function () {
                    loadOtherCatalogs(0, 21, "search", "search", $("#text-to-search").val(), {
                        json_filters: JSON.stringify(filters),
                        json_measures: JSON.stringify(measures),
                        json_capacities: JSON.stringify(capacities)
                    }, true);
                }, 100);
            }
        });
    } else {
        pushFiltersToList(filtersToList);
        // load risultati
        loadOtherCatalogs(0, 21, "search", "search", $("#text-to-search").val(), {
            filters: JSON.stringify(filters),
            json_measures: JSON.stringify(measures),
            json_capacities: JSON.stringify(capacities)
        }, true);
    }

    if(showFilterList) {
        // show "HAI FILTRATO PER:" list
        filterListUl.show();
    } else {
        filterListUl.hide();
    }
}

/**
 * rimuove un filtro
 */
function removeFilter(key, value) {

    var element = $("#search-filters").find("input:checkbox[name='"+key+"'][value='"+value+"']");
    element.prop("checked", false);

    setTimeout(function () {
        filterCatalogs();
    }, 200);
}

function removeRangeFilter(key) {

    $("#search-filters").find("input[name='"+key+"-from']").val("");
    $("#search-filters").find("input[name='"+key+"-to']").val("");

    setTimeout(function () {
        filterCatalogs();
    }, 400);
}

/**
 * generazione elemento filtro in summary
 */
var filterElementTemplate = '<li class="summary-filter-search-element"><a class="font-12 c-brown text-uppercase" href="javascript:void(0);" data-filter-key="__DATA_FILTER_KEY__" data-filter-value="__DATA_FILTER_VALUE__"><i class="fa fa-times-circle font-15 c-orange"></i> __DATA_FILTER_LABEL__</a></li>';

function generateFilterListElement(key, value, label) {

    var htmlElement = filterElementTemplate;
    htmlElement = htmlElement.replace("__DATA_FILTER_KEY__", key);
    htmlElement = htmlElement.replace("__DATA_FILTER_VALUE__", value);
    htmlElement = htmlElement.replace("__DATA_FILTER_LABEL__", label);

    return htmlElement;
}

var filterRangeElementTemplate = '<li class="summary-filter-range-search-element"><a class="font-12 c-brown text-uppercase" href="javascript:void(0);" data-filter-key="__DATA_FILTER_KEY__"><i class="fa fa-times-circle font-15 c-orange"></i> __DATA_FILTER_LABEL__</a></li>';

function generateFilterRangeListElement(key, label) {

    var htmlElement = filterRangeElementTemplate;
    htmlElement = htmlElement.replace("__DATA_FILTER_KEY__", key);
    htmlElement = htmlElement.replace("__DATA_FILTER_LABEL__", label);

    return htmlElement;
}

/**
 * aggiunge i filtri alla lista in alto
 * @param liElements
 */
function pushFiltersToList(liElements) {

    for(var i = 0; i < liElements.length; i++) {
        filterListUl.find("#filter-wrapper").append(liElements[i]);
    }
}

/**
 * ACTIONS
 */

$(document).on("click", ".summary-filter-search-element > a", function () {

    removeFilter($(this).attr("data-filter-key"), $(this).attr("data-filter-value"));

    $(this).parent('.summary-filter-search-element').remove();

    if(filterListUl.find('li').length == 0) {
        $('#remove-all-filters').addClass('d-none');
    }
});

$(document).on("click", ".summary-filter-range-search-element > a", function () {

    removeRangeFilter($(this).attr("data-filter-key"));

    $(this).parent('.summary-filter-range-search-element').remove();

    if(filterListUl.find('li').length == 0) {
        $('#remove-all-filters').addClass('d-none');
    }
});

$(".apply-search-filters-button").click(function () {

    $("#you-searched-string").text($("#text-to-search").val());
    if($("#text-to-search").val()) {
        youSearchedWrapperP.show();
    } else {
        youSearchedWrapperP.hide();
    }
    filterCatalogs(true);
});

$(".remove-all-filters > a").click(function () {

    filterListUl.find("#filter-wrapper").find(".summary-filter-search-element").remove();
    $(".search-filter-checkbox").prop("checked", false);
    filterListUl.find("#filter-wrapper").find(".summary-filter-range-search-element").remove();
    $(".search-filter-text").val("");
    filterListUl.hide();
    loadOtherCatalogs(0, 21, "search", "search", $("#text-to-search").val(), {}, true);
});